const AuthAPI = {
  login: { url: '/login', method: 'POST' },
  verifyAccount: { url: '/verify-account', method: 'POST' },
  forgotPassword: { url: '/forget-password', method: 'POST' },
  logout: { url: '/logout', method: 'POST' },
  resetPassword: { url: '/reset-password', method: 'POST' },
  createPassword: { url: '/create-password', method: 'POST' },
  refreshToken: { url: '/refresh-token', method: 'POST' },
  getProfile: { url: '/get-profile', method: 'GET' },
  updateProfile: { url: '/update-profile', method: 'POST' }, // update profile of logged in user
  deleteAccount: { url: '/delete-account', method: 'DELETE' }, // delete profile of logged in user
  updateUserProfile: { url: '/user-profile', method: 'PATCH' }, // Can update user details by passing id
  updateUserStatus: { url: '/update-user-status', method: 'POST' }, // Can update user details by passing id
  uploadMedia: { url: '/media', method: 'POSTFORMDATA' },
  updatePassword: { url: '/change-password', method: 'POST' },
  registerFFL: { url: '/ffl-register', method: 'POST' },
  registerCustomer: { url: '/register', method: 'POST' },
  customerQuickRegister: { url: '/quick-register', method: 'POST' },
  getUserProfile: { url: '/user-profile', method: 'POST' },
  getFastBoundSetting: { url: '/fast-bound-setting', method: 'GET' },
  updateFastBound: { url: '/fast-bound-setting', method: 'PATCH' },
  updateUserMenuConfig: { url: '/user-menu-config', method: 'POST' },
  deleteUserMenuConfig: { url: '/user-menu-config', method: 'DELETE' },
  getUserMenuConfig: { url: '/get-user-menu-config', method: 'POST' },
};
export default AuthAPI;
